/**
 * Venuefy central map configuration (Phase 5E) — SINGLE SOURCE OF TRUTH.
 * Two canonical maps rendered from LegacyMap_A.pdf / LegacyMap_B.pdf.
 * All pins/highlights reference IDs here; no component holds raw coordinates.
 */

export const PASSED_MESSAGE = "These hors d'oeuvres will be passed throughout the room.";
export const TABLE_SERVICE_MESSAGE = "This item will be served with your meal.";
export const EXIT_MESSAGE = "You'll receive these on your way out — near the bottom-center exit.";

// Map B stations exist only in the evening layout; Map A stations only in cocktail hour.
const MAP_B_ONLY = new Set(["how_sweet_it_is", "jalebi_baby", "brulee_bliss", "chai_there", "exit_area"]);
const MAP_A_ONLY = new Set(["bombay_station", "chaat_station", "tikka_station", "wok_station", "satis_frying_station"]);

export const MAPS = {
  A: {
    id: "A",
    src: "/venue-map-a.png",
    aspect: 3000 / 1617,
    tables: {
      1: { x: 39.2, y: 27.3 }, 2: { x: 60.7, y: 27.3 }, 3: { x: 39.2, y: 40.7 }, 4: { x: 60.7, y: 40.7 },
      5: { x: 39.1, y: 54.8 }, 6: { x: 60.7, y: 54.9 }, 7: { x: 33.2, y: 21.1 }, 8: { x: 66.8, y: 21.1 },
      9: { x: 33.1, y: 35.4 }, 10: { x: 66.7, y: 35.4 }, 11: { x: 33.0, y: 49.1 }, 12: { x: 66.7, y: 49.1 },
      13: { x: 26.9, y: 27.4 }, 14: { x: 72.9, y: 27.6 }, 15: { x: 26.9, y: 40.6 }, 16: { x: 72.9, y: 40.7 },
    },
    stations: {
      photo_booth: { label: "Photo Booth", x: 12.6, y: 18.5 },
      custom_embroidery: { label: "Custom Embroidery", x: 84.7, y: 18.6 },
      dj: { label: "DJ", x: 49.8, y: 63.8 },
      dance_floor: { label: "Dance Floor", x: 49.6, y: 39.5, area: { x1: 42.8, y1: 21.7, x2: 56.6, y2: 59.3 } },
      bombay_station: { label: "Poori Party", x: 77.3, y: 90.2 },
      chaat_station: { label: "Let's Chaat About It", x: 68.2, y: 93.5 },
      tikka_station: { label: "Tikka Chance On Me", x: 49.4, y: 72.4 },
      wok_station: { label: "Wok'n Roll", x: 21.8, y: 89.2 },
      satis_frying_station: { label: "Satis-frying", x: 31.7, y: 93.5 },
      bar_north_left: { label: "Bar (Left)", x: 12.0, y: 46.0 },
      bar_north_right: { label: "Bar (Right)", x: 84.6, y: 46.1 },
      bar_rotunda_left: { label: "Bar (Left Rotunda)", x: 12.1, y: 74.9 },
      bar_rotunda_right: { label: "Bar (Right Rotunda)", x: 87.2, y: 74.9 },
      table_service: { label: "Dining Tables", x: 49.6, y: 35.0, area: { x1: 22.0, y1: 12.0, x2: 78.0, y2: 60.0 } },
    },
  },
  B: {
    id: "B",
    src: "/venue-map-b.png",
    aspect: 3000 / 2327,
    tables: {
      1: { x: 38.0, y: 23.4 }, 2: { x: 61.5, y: 23.4 }, 3: { x: 37.9, y: 35.8 }, 4: { x: 61.1, y: 35.8 },
      5: { x: 37.9, y: 48.2 }, 6: { x: 61.1, y: 48.2 }, 7: { x: 31.5, y: 17.6 }, 8: { x: 68.8, y: 17.6 },
      9: { x: 31.2, y: 30.1 }, 10: { x: 68.4, y: 30.1 }, 11: { x: 31.2, y: 42.9 }, 12: { x: 68.4, y: 42.9 },
      13: { x: 24.5, y: 23.2 }, 14: { x: 75.1, y: 23.4 }, 15: { x: 24.5, y: 35.9 }, 16: { x: 75.3, y: 35.9 },
    },
    stations: {
      photo_booth: { label: "Photo Booth", x: 13.5, y: 16.7 },
      custom_embroidery: { label: "Custom Embroidery", x: 85.7, y: 16.7 },
      dj: { label: "DJ", x: 50.2, y: 59.2 },
      dance_floor: { label: "Dance Floor", x: 49.6, y: 36.0, area: { x1: 42.7, y1: 18.7, x2: 56.5, y2: 53.3 } },
      how_sweet_it_is: { label: "How Sweet It Is", x: 23.0, y: 83.9 },
      jalebi_baby: { label: "Jalebi Baby", x: 31.0, y: 86.4 },
      brulee_bliss: { label: "Brûlée Bliss", x: 68.9, y: 85.9 },
      chai_there: { label: "Chai There!", x: 76.9, y: 85.2 },
      exit_area: { label: "Exit Pickup", x: 49.7, y: 93.0, area: { x1: 37.0, y1: 89.0, x2: 63.0, y2: 98.5 } },
      bar_north_left: { label: "Bar (Left)", x: 12.0, y: 43.8 },
      bar_north_right: { label: "Bar (Right)", x: 87.0, y: 43.8 },
      bar_rotunda_left: { label: "Bar (Left Rotunda)", x: 12.0, y: 70.0 },
      bar_rotunda_right: { label: "Bar (Right Rotunda)", x: 87.9, y: 70.0 },
      table_service: { label: "Dining Tables", x: 49.5, y: 30.0, area: { x1: 19.0, y1: 10.0, x2: 80.0, y2: 53.0 } },
    },
  },
};

// Map A before 7:00 PM America/New_York; Map B after.
export function getActiveMapId(now = new Date()) {
  try {
    const h = parseInt(new Intl.DateTimeFormat("en-US", {
      hour: "numeric", hour12: false, timeZone: "America/New_York",
    }).format(now), 10);
    return h >= 19 ? "B" : "A";
  } catch {
    return now.getHours() >= 19 ? "B" : "A";
  }
}

// Which map a station lives on (forced), else the currently active map.
export function mapIdForStation(stationId, now = new Date()) {
  if (MAP_B_ONLY.has(stationId)) return "B";
  if (MAP_A_ONLY.has(stationId)) return "A";
  return getActiveMapId(now);
}

export function stationOn(mapId, stationId) {
  const s = MAPS[mapId]?.stations?.[stationId];
  if (!s) return null;
  return { station_id: stationId, label: s.label, x_percent: s.x, y_percent: s.y, area: s.area || null };
}

export function tableOn(mapId, tableNumber) {
  const t = MAPS[mapId]?.tables?.[Number(tableNumber)];
  return t ? { x_percent: t.x, y_percent: t.y } : null;
}

export const LEGEND_BY_MAP = {
  A: [
    { id: "photo_booth", label: "Photo Booth", marker: "PB" },
    { id: "custom_embroidery", label: "Custom Embroidery", marker: "CE" },
    { id: "dj", label: "DJ", marker: "DJ" },
    { id: "bombay_station", label: "Poori Party", marker: "PP" },
    { id: "chaat_station", label: "Let's Chaat About It", marker: "CH" },
    { id: "tikka_station", label: "Tikka Chance On Me", marker: "TK" },
    { id: "wok_station", label: "Wok'n Roll", marker: "WR" },
    { id: "satis_frying_station", label: "Satis-frying", marker: "SF" },
    { id: "dance_floor", label: "Dance Floor", marker: "DF" },
    { id: "bars", label: "Bars", marker: "B" },
    { id: "tables", label: "Tables", marker: "T" },
  ],
  B: [
    { id: "photo_booth", label: "Photo Booth", marker: "PB" },
    { id: "custom_embroidery", label: "Custom Embroidery", marker: "CE" },
    { id: "dj", label: "DJ", marker: "DJ" },
    { id: "how_sweet_it_is", label: "How Sweet It Is", marker: "HS" },
    { id: "jalebi_baby", label: "Jalebi Baby", marker: "JB" },
    { id: "brulee_bliss", label: "Brûlée Bliss", marker: "BB" },
    { id: "chai_there", label: "Chai There!", marker: "CT" },
    { id: "exit_area", label: "Exit Pickup", marker: "EX" },
    { id: "dance_floor", label: "Dance Floor", marker: "DF" },
    { id: "bars", label: "Bars", marker: "B" },
    { id: "tables", label: "Tables", marker: "T" },
  ],
};

// Stations whose pin should render as an AREA highlight instead of a point pin.
const AREA_STATIONS = new Set(["exit_area", "dance_floor"]);

/**
 * Resolve a menu item's map behavior (synchronous — config is local).
 * Returns null or { type, station, mapId, message? }.
 */
export function mapBehaviorFor(item) {
  if (!item) return null;
  const st = item.service_type;
  if (st === "PASSED") return { type: "PASSED", mapId: getActiveMapId() };
  if (st === "TABLE_SERVICE") {
    const mapId = getActiveMapId();
    return { type: "TABLE_SERVICE", mapId, station: stationOn(mapId, "table_service") };
  }
  if (st === "STATION" && item.station_id) {
    const mapId = mapIdForStation(item.station_id);
    const station = stationOn(mapId, item.station_id);
    if (!station) return null;
    if (AREA_STATIONS.has(item.station_id)) {
      return {
        type: "AREA", mapId, station,
        message: item.station_id === "exit_area" ? EXIT_MESSAGE : null,
      };
    }
    return { type: "STATION", mapId, station };
  }
  return null;
}

export function hasMapBehavior(item) {
  if (!item) return false;
  if (item.service_type === "PASSED" || item.service_type === "TABLE_SERVICE") return true;
  return item.service_type === "STATION" && !!item.station_id;
}

// Back-compat shim for callers that awaited the old API-backed config.
export async function loadMapConfig() {
  return [];
}
export function clearMapConfigCache() {}
